import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from './auth/ProtectedRoute';
import { AppShell } from './components/layouts/AppShell';
import { Showcase } from './pages/Showcase';
import WeekScheduleExample, { JobScheduleExample } from './components/scheduleView/week/WeekSchedule.example';
import LoginPage from './pages/LoginPage';
import ResetPasswordPage from './pages/ResetPasswordPage';

// Placeholder components - will be replaced during migration
const PlaceholderPage = ({ name }: { name: string }) => (
  <div style={{ padding: '2rem' }}>
    <h1>{name}</h1>
    <p>This page will be implemented during the migration.</p>
  </div>
);

// Protected pages (authentication required)
import StartPage from './pages/StartPage';
import MyProfilePage from './pages/MyProfilePage';
import SettingsPage from './pages/SettingsPage';
import JobsPage from './pages/JobsPage';
import JobApplicationsPage from './pages/JobApplicationsPage';
import JobCreatePage from './pages/JobCreatePage';
import ShiftEditPage from './pages/ShiftEditPage';
import JobSchedulePage from './pages/JobSchedulePage';
import JobEditPage from './pages/JobEditPage';
import JobDetailPage from './pages/JobDetailPage';
import TimeReportsPage from './pages/TimeReportsPage';
import ConsultantReportsPage from './pages/ConsultantReportsPage';
import SchedulePage from './pages/SchedulePage';
import WorkPlacePage from './pages/WorkPlacePage';
import ConsultantProfilePage from './pages/ConsultantProfilePage';
import StatisticsPage from './pages/StatisticsPage';
import SupportPage from './pages/SupportPage';
const TocPage = () => <PlaceholderPage name="Terms of Conditions Page" />;

// Route definitions matching Next.js routes.ts
export const routes = {
  jobCreate: '/uppdrag/skapa-uppdrag',
  jobByIdCreate: '/uppdrag/skapa-uppdrag/:id',
  jobs: '/uppdrag',
  schedule: '/schema',
  jobById: '/uppdrag/:id',
  shiftEditByJob: '/uppdrag/:id/tid',
  jobSchedule: '/uppdrag/:id/schema',
  jobApplications: '/uppdrag/ansokningar',
  reportsTime: '/rapporter/tidrapporter',
  consultantReports: '/rapporter/konsultrapporter',
  signIn: '/logga-in',
  start: '/start',
  toc: '/toc',
  stats: '/statistik',
  workPlace: '/arbetsplats',
  support: '/support',
  profile: '/konsultprofil/:id',
  myProfile: '/minprofil',
  settings: '/installningar',
};

export const publicRoutes = {
  resetPassword: '/aterstall-losenord',
  showcase: '/showcase',
  showcaseWeekSchedule: '/showcase/schema',
  showcaseJobSchedule: '/showcase/schema/uppdrag',
};

export function AppRoutes() {
  return (
    <Routes>
      {/* Root redirect */}
      <Route path="/" element={<Navigate to={routes.start} replace />} />

      {/* Public routes */}
      <Route path={routes.signIn} element={<LoginPage />} />
      <Route path={publicRoutes.resetPassword} element={<ResetPasswordPage />} />
      <Route path={publicRoutes.showcase} element={<Showcase />} />
      <Route path={publicRoutes.showcaseWeekSchedule} element={<WeekScheduleExample />} />
      <Route path={publicRoutes.showcaseJobSchedule} element={<JobScheduleExample />} />

      {/* Protected routes - share a single AppShell so the sidebar/navbar stays mounted across navigations */}
      <Route
        element={
          <ProtectedRoute>
            <AppShell />
          </ProtectedRoute>
        }
      >
        <Route path={routes.start} element={<StartPage />} />
        <Route path={routes.jobs} element={<JobsPage />} />
        <Route path={routes.jobById} element={<JobDetailPage />} />
        <Route path={routes.shiftEditByJob} element={<ShiftEditPage />} />
        <Route path={routes.jobSchedule} element={<JobSchedulePage />} />
        <Route path={routes.jobApplications} element={<JobApplicationsPage />} />
        <Route path={routes.jobCreate} element={<JobCreatePage />} />
        <Route path={routes.jobByIdCreate} element={<JobEditPage />} />
        <Route path={routes.reportsTime} element={<TimeReportsPage />} />
        <Route path={routes.consultantReports} element={<ConsultantReportsPage />} />
        <Route path={routes.schedule} element={<SchedulePage />} />
        <Route path={routes.workPlace} element={<WorkPlacePage />} />
        <Route path={routes.myProfile} element={<MyProfilePage />} />
        <Route path={routes.profile} element={<ConsultantProfilePage />} />
        <Route path={routes.settings} element={<SettingsPage />} />
        <Route path={routes.stats} element={<StatisticsPage />} />
        <Route path={routes.support} element={<SupportPage />} />
        <Route path={routes.toc} element={<TocPage />} />
      </Route>

      {/* 404 Not Found */}
      <Route path="*" element={<PlaceholderPage name="404 - Page Not Found" />} />
    </Routes>
  );
}
